/** 一个滚动章节的叙事卡片：背景画笔图片、标题、正文和出现音效。 */
import classNames from 'classnames';
import { Howl } from 'howler';
import { forwardRef, HTMLAttributes, useEffect, useState } from 'react';
import { useSoundConfigState } from '../../../atoms/sound-config';
import { supportsWebp } from '../../../utils/supports-webp';

interface Props extends HTMLAttributes<HTMLElement> {
    title: string;
    text: string;
    bgUrl?: string;
    classPostfix: string;
    visible?: boolean;
}

const Message = forwardRef<HTMLDivElement, Props>(
    (
        {
            title,
            text,
            bgUrl = `/img/message-bg.${supportsWebp ? 'webp' : 'png'}`,
            classPostfix,
            visible = false,
            ...props
        },
        ref,
    ) => {
        const [soundConfig] = useSoundConfigState();
        // 每个 Message 实例拥有自己的出现音效对象，但只会创建一次。
        const [revealSound] = useState<Howl>(
            () =>
                new Howl({
                    src: ['/sounds/message-reveal-new.wav'],
                    volume: 1,
                }),
        );

        useEffect(() => {
            // 章节第一次/再次变为可见时播放提示音；静音模式下完全跳过。
            if (soundConfig.enabled && visible) {
                revealSound.play();
            }
        }, [visible, revealSound, soundConfig.enabled]);

        return (
            <div
                {...props}
                ref={ref}
                className={classNames(
                    'message',
                    `message-${classPostfix}`,
                    props.className,
                    { 'is-visible': visible },
                )}
            >
                <img
                    src={bgUrl}
                    className="message__bg"
                    alt=""
                    loading="lazy"
                    decoding="async"
                />
                <div className="message__title">{title}</div>
                <div
                    className="message__text"
                    // text 来自本地静态 data.ts，不接收用户输入；保留原文中的 HTML 排版能力。
                    dangerouslySetInnerHTML={{ __html: text }}
                ></div>
            </div>
        );
    },
);

Message.displayName = 'Message';

export default Message;
